import './tabs.component.scss';

export default {
  template: require('./tabs.component.html'),
  transclude: true,
  controller: function () {
    'ngInject';
  }
};
